<script>
import cloneDeep from 'lodash/cloneDeep'
import { nameListComputed, nameListMethods } from '@state/helpers/name-list'
import {
  memberEditComputed,
  memberEditMethods,
} from '@state/helpers/member-edit'
import { STATUS_REQUEST } from '@utils/constant'
import editItems from './editItems'
export default {
  page: {
    title: 'Edit Member',
    meta: [{ name: 'description', content: 'The Member Edit page.' }],
  },
  props: {
    pickerType: {
      type: String,
      default: '',
      require: false,
    },
  },
  data() {
    return {
      checkedList: [],
      items: [],
      title: this.$t('pages.editMember'),
    }
  },
  computed: {
    ...nameListComputed,
    ...memberEditComputed,
    nameListComputed() {
      const options = cloneDeep(this.getNameList)
      return options?.list?.map((item, index) => {
        if (index === 0) {
          return { value: item.id, label: item.company, disabled: true }
        } else {
          return { value: item.id, label: item.company }
        }
      })
    },
    errorServerSideComputed() {
      return this.getErrors
    },
  },
  watch: {
    getStatus() {
      if (this.getStatus === STATUS_REQUEST.SUCCESS) {
        this.resetMemberEdit()
        this.backToListPage()
      }
    },
    nameListComputed() {
      this.items.map((item) => {
        if (item.key === 'agent_ids') {
          item.options = this.nameListComputed
        } else {
          return item.options
        }
      })
    },
    getMemberDetails() {
      const dataMember = cloneDeep(this.getMemberDetails)
      this.checkedList = dataMember.agent_list.map((member) => {
        return member.agent_id
      })
      this.items = this.items.map((item) => {
        if (item.key === 'agent_ids') {
          item.checked = this.checkedList
          item.value = this.checkedList
        } else if (item.key === 'gender') {
          item.checked = `${dataMember.gender}`
          item.value = parseInt(item.checked, 10)
        } else if (item.key === 'athlete') {
          item.checked = `${dataMember.athlete}`
          item.value = parseInt(item.checked, 10)
        }
        if (dataMember[item.key]) {
          item.value = dataMember[item.key]
        }
        return item
      })
    },
  },
  created() {
    this.fetchingNameList()
    this.handleGetMemberDetails()
  },
  mounted() {
    this.initItems()
  },
  methods: {
    ...memberEditMethods,
    ...nameListMethods,
    initItems() {
      this.items = cloneDeep(editItems)
    },
    handleEditMember() {
      this.formatNumber()
      const { id } = this.$route.params
      const payload = this.items.reduce((results, item) => {
        results[item.key] = item.value
        return results
      }, {})
      this.editMember({ ...payload, id: parseInt(id, 10) })
    },
    handleUpdateCheckbox(field, value) {
      this.items.map((item) => {
        if (item.name === field) {
          item.value = [...value, 1]
        }
      })
      return this.items
    },
    handleUpdate(value) {
      this.items.map((item) => {
        if (item.name === 'birthday') {
          item.value = value
        }
      })
    },
    handleUpdateRadio(field, value) {
      this.items.map((item) => {
        if (item.name === field) {
          item.value = value
        }
      })
    },
    formatNumber() {
      this.items[7].value = parseInt(this.items[7].value)
      this.items[5].value = parseInt(this.items[5].value)
      this.items[8].value = parseInt(this.items[8].value)
      return this.items
    },
    handleCancel() {
      this.initItems()
      this.backToListPage()
    },
    backToListPage() {
      this.$router.push({
        path:
          '/panel/member-list/detail/' +
          this.$route.params.id +
          '/' +
          this.$route.params.agent_id,
      })
    },
    handleGetMemberDetails() {
      const id = this.$route.params.id
      this.fetchingMemberDetails({ id })
    },
    isComfirmedPassword() {
      if (this.items[2].value !== '' && this.items[3].value !== '') {
        return 'password'
      } else {
        return false
      }
    },
    isRequiredPassword(key) {
      const field = {
        passwordConfirm: 4,
        password: 3,
      }
      if (this.items[field[key]].value !== '') {
        return true
      }
      return false
    },
  },
}
</script>

<template>
  <BaseAddNewCard
    :errors="errorServerSideComputed"
    type="edit"
    @submit="handleEditMember"
    @cancel="handleCancel"
  >
    <template v-slot:header>
      <h5 class="card-title">{{ title }}</h5>
    </template>
    <template v-slot>
      <CRow v-for="item in items" :key="item.key">
        <CCol sm="3">
          {{ item.label }}
          <span v-if="item.rules" class="text-danger">*</span>
        </CCol>
        <CCol :sm="item.as === 'checkbox' ? 9 : 3">
          <BaseCheckboxGroup
            v-if="item.as === 'checkbox'"
            inline
            :rules="item.rules"
            :name="item.name"
            :options="item.options"
            :checked="checkedList"
            @update:checked="(v) => handleUpdateCheckbox(item.name, v)"
          />
          <BaseRadioGroup
            v-if="item.as === 'radio'"
            inline
            :rules="item.rules"
            :name="item.name"
            :options="item.options"
            :checked.sync="item.checked"
            custom
            @update:checked="(v) => handleUpdateRadio(item.name, v)"
          />
          <BaseDatePicker
            v-if="item.as === 'datepicker'"
            :picker-type="pickerType"
            :rules="item.rules"
            :init-date="item.value"
            @update:date="(v) => handleUpdate(v)"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password'"
            v-model="item.value"
            :rules="{
              password: true,
              required:
                isRequiredPassword('passwordConfirm') && item.value.length <= 0,
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'password_2'"
            v-model="item.value"
            :rules="{
              password: true,
              required:
                isRequiredPassword('password') && item.value.length <= 0,
              confirmed: isComfirmedPassword(),
            }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="new-password"
          />
          <BaseInput
            v-if="item.as === 'input' && item.key === 'email'"
            v-model="item.value"
            :rules="{ ...item.rules, ...{ required: item.value.length <= 0 } }"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="off"
          />
          <BaseInput
            v-if="
              item.as === 'input' &&
                item.key !== 'password' &&
                item.key !== 'password_2' &&
                item.key !== 'email'
            "
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            autocomplete="off"
          />
        </CCol>
      </CRow>
    </template>
  </BaseAddNewCard>
</template>

<style lang="scss" scoped>
::v-deep .mx-datepicker[data-v-8d8a95e0] {
  width: 100% !important;
}
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
